import * as React from "react";
const SvgBarChartHorizontalFill = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="M12 3v4H3V3zm4 14v4H3v-4zm6-7v4H3v-4z" /></svg>;
export default SvgBarChartHorizontalFill;